module.exports = __webpack_public_path__ + "img/教研中心.388c5def.png";